var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#C70048"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 31.7071C19.9024 31.3166 19.9024 30.6834 20.2929 30.2929L26.6569 23.9289C27.0474 23.5384 27.6805 23.5384 28.0711 23.9289C28.4616 24.3195 28.4616 24.9526 28.0711 25.3431L22.4142 31L28.0711 36.6569C28.4616 37.0474 28.4616 37.6805 28.0711 38.0711C27.6805 38.4616 27.0474 38.4616 26.6569 38.0711L20.2929 31.7071ZM40 32H21V30H40V32Z",
    fill: "#C70048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBack);
export default __webpack_public_path__ + "static/media/circleBack.7fdd15bc1f54993481633c069ecf3db8.svg";
export { ForwardRef as ReactComponent };